import { getApi } from "./api";

export const GET_HOME_API = {
  method: "GET",
  url: "/patient/get-today",
};

export const getHome = async (doctorId) => {
  try {
    const response = await getApi(GET_HOME_API.url, { doctorId });
    return response.data;
  } catch (error) {
    return error;
  }
};
